module.exports = __webpack_public_path__ + "static/scale-model-of-providence-ghost-tour-in-providence-rhode-island-bb641f4ec6c8673b204454cc56b97e8e.png";